import { createSlice } from '@reduxjs/toolkit'

export const counterSlice = createSlice({
  name: 'user',
  initialState: {
    user: {} ,
  },
  reducers: {
    setUser: (state,action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes.
      // Also, no return statement is required from these functions.
      console.log('setting state.user==',action.payload);
      state.user = action.payload ;
    },
    logout: (state) => {
      state.user = {};
    },
    
  },
})

// Action creators are generated for each case reducer function
export const { setUser, logout } = counterSlice.actions

export default counterSlice.reducer